import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);

if (document.querySelector(".dashboard")) {
    // ==============================
    // 🔹 FIX CHART DISPLAY
    // ==============================
    var salesChartInstance = null; // Store chart instance
    var salesDonutChartElement = document.getElementById("salesDonutChart");

    if (salesDonutChartElement) {
        var salesDonutChartCtx = salesDonutChartElement.getContext("2d");

        fetch(`/dashboard/get-sales-stages${location.search}`)
            .then(response => response.json())
            .then(data => {
                console.log("✅ Fetched Chart Data:", data); // Debugging log

                if (!data || data.length === 0) {
                    console.error("⚠️ No data received for chart.");
                    return;
                }

                let labels = data.map(item => item.sales_stage);
                let values = data.map(item => Number(item.contact_count)); // Ensure numerical values

                // 🔹 Define the **minimum visual size** (adjustable)
                const MIN_VISUAL_SIZE = 5; // Minimum percentage visibility
                const totalOriginal = values.reduce((sum, v) => sum + v, 0);

                if (totalOriginal === 0) {
                    console.warn("⚠️ No valid data for chart.");
                    return;
                }

                // 🔹 Convert values to percentages
                let percentages = values.map(value => (value / totalOriginal) * 100);

                // 🔥 Ensure every section has **at least** `MIN_VISUAL_SIZE`
                let boostedPercentages = percentages.map(pct => (pct < MIN_VISUAL_SIZE ? MIN_VISUAL_SIZE : pct));

                // 🔹 Adjust total so it sums to 100%
                const boostedTotal = boostedPercentages.reduce((sum, p) => sum + p, 0);
                let finalPercentages = boostedPercentages.map(pct => (pct / boostedTotal) * 100);

                // 🔹 Convert back to absolute values for Chart.js (purely visual)
                let adjustedValues = finalPercentages.map(pct => (pct / 100) * totalOriginal);

                console.log("🎯 Adjusted Values (Visual Only):", adjustedValues);

                // 🔥 Destroy existing chart before creating a new one
                if (salesChartInstance) {
                    salesChartInstance.destroy();
                }

                // Now Load in Sales Pipeline //

                fetch(`/dashboard/get-sales-pipeline${location.search}`)
                    .then(response => response.json())
                    .then(data => {
                        if (!data || data.error) {
                            console.error("❌ Error loading sales pipeline data:", data.error);
                            return;
                        }

                        // 🔹 Define the correct sales stage order
                        let orderedStages = ["Prospect", "Qualified", "Short Stack", "Won", "Delayed Decision", "Lost"];

                        // 🔹 Ensure labels & values are ordered properly
                        let labels = orderedStages;
                        let salesStageValues = orderedStages.map(stage => {
                            let index = data.labels ? data.labels.indexOf(stage) : -1;
                            return index !== -1 ? (data.sales_stage_values[index] ?? 0) : 0;
                        });

                        let salesStagePercentages = orderedStages.map(stage => {
                            let index = data.labels ? data.labels.indexOf(stage) : -1;
                            return index !== -1 ? (data.sales_stage_percentages[index] ?? 0) : 0;
                        });

                        // 🔥 If labels or data are missing, retry fetching
                        if (!data.labels || labels.length === 0 || salesStageValues.length === 0) {
                            if (attempts > 0) {
                                console.warn(`⚠️ Retrying chart data fetch... Attempts left: ${attempts}`);
                                setTimeout(() => loadChartData(attempts - 1), 500);
                            } else {
                                console.error("❌ Final attempt failed: No valid data for chart.");
                            }
                            return;
                        }


                        // ✅ Create new Chart with VISUAL adjustments (Data remains intact)
                        salesChartInstance = new Chart(salesDonutChartCtx, {
                            type: "doughnut",
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: adjustedValues, // 🚀 Visually adjusted data
                                    backgroundColor: ["#007bff", "#28a745", "#ffc107", "#dc3545", "#6f42c1"],
                                    borderWidth: 2,
                                }]
                            },
                            options: {
                                responsive: true,
                                maintainAspectRatio: false,
                                cutout: "60%",
                                plugins: {
                                    legend: { display: false }, // Hide legend
                                    tooltip: {
                                        enabled: true,
                                        callbacks: {
                                            label: function (tooltipItem) {
                                                let index = tooltipItem.dataIndex;
                                                return  [
                                                    `${labels[index]}: ${values[index]} Contacts`,
                                                    `Total Value ($): $${salesStageValues[index].toLocaleString()}`
                                                ]; // ✅ Return an array to create multiple lines
                                            }
                                        }
                                    },
                                    datalabels: {
                                        color: "white",
                                        font: { weight: "bold", size: 16 },
                                        padding: { top: 2 }, // Adds 2px top padding
                                        formatter: (value, context) => values[context.dataIndex] // 🔥 Show correct original value inside chart
                                    }
                                }
                            },
                            plugins: [ChartDataLabels] // Ensure the plugin is loaded
                        });

                    });

            })
            .catch(error => console.error("⚠️ Error fetching chart data:", error));
    } else {
        console.error("⚠️ Chart element not found!");
    }

    // ==============================
    // 🔹 FETCH DASHBOARD METRICS (Revenues, etc.)
    // ==============================
    axios.get(`/dashboard/get-dashboard-metrics${location.search}`)
        .then(response => {
            const data = response.data;
            console.log("✅ Fetched Dashboard Data:", data); // Debugging log

            if (data.error) {
                console.error("⚠️ Error fetching revenue data:", data.error);
                return;
            }

            document.getElementById("sales-ytd-card").innerText = `$${data.sales_ytd}`;
            document.getElementById("sales-mtd-card").innerText = `$${data.sales_mtd}`;
            document.getElementById("quotes-mtd-card").innerText = `${data.quotes_mtd}`;
            document.getElementById("samples-mtd-card").innerText = `${data.samples_mtd}`;
            document.getElementById("win-ytd-card").innerText = `${data.win_ytd}%`;
        })
        .catch(error => console.error("⚠️ Error fetching dashboard metrics:", error));

    function loadChartData(attempts = 5) {
        fetch(`/dashboard/get-sales-pipeline${location.search}`)
            .then(response => response.json())
            .then(data => {
                console.log("✅ Sales Pipeline Chart Data:", data);

                if (!data || data.error) {
                    console.error("❌ Error loading sales pipeline data:", data.error);
                    return;
                }

                // 🔹 Define the correct sales stage order
                let orderedStages = ["Prospect", "Qualified", "Short Stack", "Won", "Delayed Decision", "Lost"];

                // 🔹 Ensure labels & values are ordered properly
                let labels = orderedStages;
                let salesStageValues = orderedStages.map(stage => {
                    let index = data.labels ? data.labels.indexOf(stage) : -1;
                    return index !== -1 ? (data.sales_stage_values[index] ?? 0) : 0;
                });

                let salesStagePercentages = orderedStages.map(stage => {
                    let index = data.labels ? data.labels.indexOf(stage) : -1;
                    return index !== -1 ? (data.sales_stage_percentages[index] ?? 0) : 0;
                });

                // 🔥 If labels or data are missing, retry fetching
                if (!data.labels || labels.length === 0 || salesStageValues.length === 0) {
                    if (attempts > 0) {
                        console.warn(`⚠️ Retrying chart data fetch... Attempts left: ${attempts}`);
                        setTimeout(() => loadChartData(attempts - 1), 500);
                    } else {
                        console.error("❌ Final attempt failed: No valid data for chart.");
                    }
                    return;
                }

                // 🔥 Destroy previous chart instance before creating a new one
                if (window.salesPipelineChartInstance) {
                    try {
                        window.salesPipelineChartInstance.destroy();
                    } catch (e) {
                        console.warn("⚠️ Chart destroy failed:", e);
                    }
                }
            })
            .catch(error => {
                console.error("❌ Error fetching sales pipeline data:", error);
            });
    }

    // ✅ Load chart data initially
    loadChartData();

    const bitlyDailyClicksWidget = document.querySelector('.bitly-daily-clicks-widget');
    if (document.querySelector(".bitly-daily-clicks-widget")) {
        let currentChart = null;
        async function loadBitlyDailyClicks(widget, bitlink){
            const base = widget.dataset.endpoint;
            if (!base || !bitlink) return;
            const url = `${base}?bitlink=${encodeURIComponent(bitlink)}`;
            const metaEl = widget.querySelector('.bitly-meta');
            const canvas = document.getElementById('bitlyDailyClicksChart');

            if (metaEl) metaEl.textContent = 'Loading...';

            try {
                const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
                if (!res.ok) throw new Error('HTTP ' + res.status);
                const json = await res.json();
                if (json.error) throw new Error(json.error);

                metaEl.textContent = `Total: ${json.total}`;

                const ctx = canvas.getContext('2d');
                const gradient = ctx.createLinearGradient(0,0,0,180);
                gradient.addColorStop(0,'rgba(54,162,235,0.35)');
                gradient.addColorStop(1,'rgba(54,162,235,0.02)');

                if (currentChart) currentChart.destroy();

                const maxY = Math.max(...json.values);
                const paddedMax = Math.ceil(maxY);

                currentChart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: json.labels,
                        datasets: [{
                            label: 'Clicks',
                            data: json.values,
                            fill: true,
                            backgroundColor: gradient,
                            borderColor: 'rgba(54,162,235,1)',
                            borderWidth: 2,
                            pointRadius: 3,
                            tension: 0.25
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        interaction: { mode: 'index', intersect: false },
                        scales: {
                            x: { ticks: { maxRotation: 0, autoSkip: true }, grid: { display: false } },
                            y: {
                                beginAtZero: true,
                                suggestedMax: paddedMax,
                                ticks: {
                                    callback: v => Math.ceil(v), // ceil each tick
                                    precision: 0,
                                    stepSize: Math.ceil(paddedMax / 5) // optional: control number of ticks
                                },
                                grid: { color: 'rgba(0,0,0,0.05)' }
                            }
                        },
                        plugins: {
                            tooltip: { callbacks: { label: c => `${c.parsed.y} clicks` } },
                            legend: { display: false }
                        }
                    }
                });
            } catch (e) {
                if (metaEl) metaEl.textContent = 'Error';
                console.error('Bitly daily clicks load failed:', e);
            }
        }

        const select = bitlyDailyClicksWidget.querySelector('.bitly-link-select');
        if (select) {
            loadBitlyDailyClicks(bitlyDailyClicksWidget, select.value);
            select.addEventListener('change', () => loadBitlyDailyClicks(bitlyDailyClicksWidget, select.value));
        }
    }

    const bitlyReferrersPeriodWidget = document.querySelector('.bitly-referrers-period-widget');
    if (bitlyReferrersPeriodWidget) {
        let referrersChart = null;

        // JavaScript
        async function loadBitlyReferrersPeriod(widget, bitlink, period) {
            const base = widget.dataset.endpoint;
            if (!base) {
                console.warn('Missing endpoint data-endpoint on widget.');
                return;
            }

            const url = `${base}?bitlink=${encodeURIComponent(bitlink)}&period=${period}`; // <- change back if needed
            const metaEl = widget.querySelector('.bitly-meta');
            const canvas = document.getElementById('bitlyReferrersPeriodChart');
            if (!canvas) {
                console.error('Canvas #bitlyReferrersPeriodChart not found.');
                return;
            }
            if (metaEl) metaEl.textContent = 'Loading...';

            try {
                const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
                if (!res.ok) throw new Error('HTTP ' + res.status);
                const json = await res.json();
                if (json.error) throw new Error(json.error);

                let labels = json.labels;
                let values = json.values;
                const total = json.total;

                if (metaEl) metaEl.textContent = `Total: ${total}`;

                const ctx = canvas.getContext('2d');
                const colors = labels.map((_, i) => `hsl(${(i * 47) % 360} 70% 55%)`);

                if (referrersChart) referrersChart.destroy();

                referrersChart = new Chart(ctx, {
                    type: 'doughnut',
                    data: {
                        labels,
                        datasets: [{
                            data: values,
                            backgroundColor: colors,
                            borderColor: '#fff',
                            borderWidth: 2,
                            cutout: '55%'
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            tooltip: {
                                callbacks: {
                                    label: (item) => {
                                        const value = item.parsed;
                                        const t = values.reduce((a,b)=>a+b,0);
                                        const pct = t ? ((value / t) * 100).toFixed(1) : 0;
                                        return `${item.label}: ${value} (${pct}%)`;
                                    }
                                }
                            },
                            legend: { position: 'right' },
                            datalabels: {
                                color: '#fff',
                                font: { weight: 'bold' },
                                formatter: (val, ctx) => {
                                    const t = values.reduce((a,b)=>a+b,0);
                                    const pct = t ? ((val / t) * 100).toFixed(0) : 0;
                                    return `${pct}%`;
                                }
                            }
                        }
                    },
                    plugins: [ChartDataLabels]
                });
            } catch (e) {
                if (metaEl) metaEl.textContent = 'Error';
                console.error('Bitly referrers period load failed:', e);
            }
        }

        const linkSelect = bitlyReferrersPeriodWidget.querySelector('.bitly-link-select');
        const periodSelect = bitlyReferrersPeriodWidget.querySelector('.bitly-period-select');

        loadBitlyReferrersPeriod(bitlyReferrersPeriodWidget, linkSelect.value, periodSelect.value);
        linkSelect.addEventListener('change', () => {
            loadBitlyReferrersPeriod(bitlyReferrersPeriodWidget, linkSelect.value, periodSelect.value);

            const url = new URL(window.location);
            url.searchParams.delete('bitly-link');
            window.history.pushState({}, '', url);
        });
        periodSelect.addEventListener('change', () => loadBitlyReferrersPeriod(bitlyReferrersPeriodWidget, linkSelect.value, periodSelect.value));
    }
}
